const ApplicationException = require('exceptions/ApplicationException');
const ArgumentException = require('exceptions/ArgumentException');
const ArgumentNullException = require('exceptions/ArgumentNullException');
const ArgumentOutOfRangeException = require('exceptions/ArgumentOutOfRangeException');
const NotImplementedException = require('exceptions/NotImplementedException');

module.exports = {
    ApplicationException,
    ArgumentException,
    ArgumentNullException,
    ArgumentOutOfRangeException,
    NotImplementedException
};
